<form class="card mt-2">
  <div class="card-body">
    <h2 class="mb-3">Reports</h2>

    <div class="btn-group mb-3" role="group">
      <button type="button" routerLink="/employee/census" class="btn btn-outline-secondary">Census Report</button>
      <button type="button" routerLink="/employee/terminated" class="btn btn-primary">Separation Report</button>
    </div>

    <div class="btn-group mb-3 ml-2" role="group" *ngIf="canViewEmployeeExclusionReports">
      <button type="button" routerLink="/employee/exclusion-reports" [queryParams]="{reportType: 'LEIE'}" class="btn btn-outline-primary">LEIE Database</button>
      <button type="button" routerLink="/employee/exclusion-reports" [queryParams]="{reportType: 'SAMS'}" class="btn btn-outline-primary">SAMS Database</button>
    </div>

    <h3 class="mb-3">Separation Report</h3>
    <div class="mb-3">

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Campus:</h5>
        </div>
        <div class="col-10">
          <i *ngIf="!campusList" class="material-icons rotate text-muted">loop</i>
          <p-select styleClass="app-select ml-2 w-100 mb-2" [options]="campusList" [(ngModel)]="campusId" (ngModelChange)="reloadList(this.filter)" [ngModelOptions]="{standalone: true}"></p-select>
        </div>
      </div>

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Employee:</h5>
        </div>
        <div class="col-10">
          <div class="ml-2 w-100 mb-2">
            <p-autoComplete [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}" [(ngModel)]="selectedUserEmployee"
                            [suggestions]="userEmployeeList" (completeMethod)="getStaffList($event)" field="name" dataKey="id"
                            [ngModelOptions]="{standalone: true}" [minLength]="1" [autoHighlight]="true"
                            (onSelect)="reloadListAfterStaffChage($event)" [forceSelection]="true"
                            (onClear)="reloadListAfterClear($event)"></p-autoComplete>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Separation Date:</h5>
        </div>
        <div class="col-10">
          <i *ngIf="!dateRangeList" class="material-icons rotate text-muted">loop</i>
          <p-select styleClass="app-select ml-2 w-100 mb-2" [options]="dateRangeList" optionLabel="text" [(ngModel)]="dateRange" (ngModelChange)="changedDateRange()" [ngModelOptions]="{standalone: true}"></p-select>
        </div>
      </div>

      <div class="row" *ngIf="isCustomDateRange">
        <div class="col-2 d-flex align-items-center">
          <h5>Start Date:</h5>
        </div>
        <div class="col-10">
          <input type="date" class="form-control ml-2 w-100 mb-2" [(ngModel)]="startDate" (blur)="reloadList(this.filter)" [ngModelOptions]="{standalone: true}" />
        </div>
        <div class="col-2 d-flex align-items-center">
          <h5>End Date:</h5>
        </div>
        <div class="col-10">
          <input type="date" class="form-control ml-2 w-100 mb-2" [(ngModel)]="endDate" (blur)="reloadList(this.filter)" [ngModelOptions]="{standalone: true}" />
        </div>
      </div>
            
    </div>
    <i [hidden]="!loadingTerminationList && !loadingTerminationExcel" class="material-icons rotate text-muted">loop</i>
    <button type="button" title="Export all pages to excel" class="btn btn-success mr-2 mb-2" (click)="exportToExcel()"><i class="far fa-file-excel"></i></button>
    <p-table #myTable [value]="list?.result" [responsive]="true" [paginator]="true" [rows]="20"
             [totalRecords]="list?.totalRecords" [lazy]="true" (onLazyLoad)="reloadList($event)">
      <ng-template pTemplate="header">
        <tr>
          <th width="100px"></th>
          <th>Employee SSN</th>
          <th [pSortableColumn]="'LastName'">Legal Last Name <p-sortIcon [field]="'LastName'"></p-sortIcon></th>
          <th [pSortableColumn]="'FirstName'">Legal First Name <p-sortIcon [field]="'FirstName'"></p-sortIcon></th>
          <th [pSortableColumn]="'TerminationDate'">Separation Date <p-sortIcon [field]="'TerminationDate'"></p-sortIcon></th>
          <th [pSortableColumn]="'TerminationReason'">Separation Type <p-sortIcon [field]="'TerminationReason'"></p-sortIcon></th>
          <th>Separation Reasons</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-list>
        <tr>
          <td>
            <button class="btn btn-secondary mr-2" *ngIf="canEditUser" (click)="editEmployee(list)" title="Edit Employee Info">
              <i class="fas fa-edit"></i>
            </button>
          </td>
          <td>
            <span class="ui-column-title">Employee</span>
            {{list.employeeSSN}}
          </td>
          <td>
            <span class="ui-column-title">Legal Last Name</span>
            {{list.lastName}}
          </td>
          <td>
            <span class="ui-column-title">Legal First Name</span>
            {{list.firstName}}
          </td>
          <td>
            <span class="ui-column-title">Separation Date</span>
            {{list.terminationDate | date: 'MM/dd/yyyy'}}
          </td>
          <td>
            <span class="ui-column-title">Separation Type</span>
            {{list.terminationReason}}
          </td>
          <td style="white-space: pre-line;">
            <span class="ui-column-title">Separation Reasons</span>
            {{list.subReasons.join("\n")}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorleft" let-state>
          Showing {{ state.first + 1 }} - {{ (state.first + state.rows) > state.totalRecords ? state.totalRecords : (state.first + state.rows) }} of {{ state.totalRecords }} entries
      </ng-template>
      <ng-template pTemplate="paginatorright">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
                <span style="color: #495057; font-size: 14px; white-space: nowrap;">Rows per page:</span>
                <p-dropdown 
                    [options]="dropdownOptions()" 
                    optionLabel="label" 
                    optionValue="value"
                    [ngModel]="myTable.rows" 
                    (onChange)="myTable.rows = $event.value; myTable.reset()">
                </p-dropdown>
            </div>
      </ng-template>

    </p-table>
  </div>
</form>
